import { jsx as _jsx } from "react/jsx-runtime";
import { getInitials } from "@common/util/initials";
import { useMemo } from "react";
import { cls } from "views/NUI/utils";
import { getAvatarRGBFromName } from "xAppLib/Avatar/avatarColours";
function toHex(value) {
    return value.toString(16).padStart(2, "0");
}
function getAutoColorStyle(name) {
    const { r, g, b } = getAvatarRGBFromName(name);
    const yiqLuma = r * 0.299 + g * 0.587 + b * 0.114;
    const isDark = yiqLuma < 128;
    return {
        backgroundColor: `#${toHex(r)}${toHex(g)}${toHex(b)}`,
        color: isDark ? "#ffffff" : "#333333",
    };
}
export const Avatar = ({ name, size = 50, style, className, autoColor = true }) => {
    const { initials, avatarStyle } = useMemo(() => {
        const initials = getInitials(name);
        const dim = size / 16;
        const colorStyle = autoColor ? getAutoColorStyle(name) : {};
        const avatarStyle = Object.assign(Object.assign({ width: `${dim}rem`, height: `${dim}rem`, fontSize: `${dim / 2.5}rem`, fontFamily: "Calibri, sans-serif", userSelect: "none" }, colorStyle), style);
        return { initials, avatarStyle };
    }, [name, size, style, autoColor]);
    return (_jsx("div", { className: cls("rounded-full border-white border-2 flex items-center justify-center", className), style: avatarStyle, children: initials }));
};
